import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsProofModalOpen = createStore(() => useState(false));
